/**
      *@@*    .@@(     %@@   ,@@@&    @@#     @@(    .@@#        #@@@@@@@,    
     ,@@@@,    .@@*   #@@    ,@@@@@.  @@#     @@(    .@@#        #@@   ,@@/   
    ,@@..@@*    .@@, (@@     ,@@,*@@/ @@#     @@(    .@@@@@@@%   #@@@@@@@&    
   ,@@@@@@@@,    .@@(@@.     ,@@,  @@%@@#     @@(    .@@#        #@@ .@@/     
  ,@@,    *@@,    .@@@.      ,@@,   %@@@#     @@(    .@@#        #@@   @@&  
**/

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.dropdownHandle = "";

    this.querySelectorAll(
      ".mega-menu__item:not(.mega-menu__item--link)"
    ).forEach((item) => {
      item.addEventListener("mouseenter", (elem) => {
        const e = elem;
        setTimeout(
          function () {
            if (item.matches(":hover")) {
              this.dropdownHandle = item.getAttribute("data-handle");
              this.querySelectorAll(
                ".mega-menu__item:not(.mega-menu__item--link)"
              ).forEach((dropdown) => {
                dropdown.classList.remove("actif");
              });
              item.classList.add("actif");
              this.openDropdown(item);
            }

          }.bind(this),
          150
        );
      });
    });

    this.addEventListener("mouseleave", this.closeDropdown.bind(this));
    this.querySelectorAll('.mega-menu__item--link').forEach((item) => {
      item.addEventListener("mouseenter", (elem) => {
        const e = elem;
        setTimeout(
          function () {
            this.closeDropdown()
          }.bind(this),
          150
        );
      });
    })
  }

  setHandle(e) {

  }

  openDropdown(e) {
    this.activeHeader();
    document.body.classList.add("menu-opened");
    this.querySelector(".mega-menu__dropdown").classList.add(
      "mega-menu__dropdown-actif"
    );
    this.querySelectorAll(".mega-menu__dropdown-item").forEach((dropdown) => {
      dropdown.classList.remove("mega-menu__dropdown-item-actif");
      if (
        dropdown.getAttribute("data-handle-dropdown") == this.dropdownHandle
      ) {
        dropdown.classList.add("mega-menu__dropdown-item-actif");
      } else {
        dropdown.classList.remove("mega-menu__dropdown-item-actif");
      }
    });
    document
      .querySelector(".header")
      .classList.add("shopify-section-header-sticky");
  }

  closeDropdown(e) {
    this.desactiveHeader();
    document.body.classList.remove("menu-opened");
    this.querySelector(".mega-menu__dropdown").classList.remove(
      "mega-menu__dropdown-actif"
    );
    this.querySelectorAll(
      ".mega-menu__item:not(.mega-menu__item--link)"
    ).forEach((dropdown) => {
      dropdown.classList.remove("actif");
    });
    document
      .querySelector(".header")
      .classList.remove("shopify-section-header-sticky");
  }
  activeHeader(e) {
    document.querySelector(".header").classList.add("header--hover");
  }

  desactiveHeader(e) {
    document.querySelector(".header").classList.remove("header--hover");
  }
}

customElements.define("mega-menu", MegaMenu);
